import React from 'react';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';

const styles = theme => ({});

const AfitdBox = props => {
    const { isHidden, children, ...otherProps } = props;

    return isHidden ? null : <Box {...otherProps}>{children}</Box>;
};

// export default AfitdBox;
export default withStyles(styles)(AfitdBox);
